import {
  FILE_LOADED,
  LOAD_FEATURE_FLAGS,
  NEW_FILE,
  SET_FEATURE_FLAG,
  UNSET_FEATURE_FLAG,
} from '../constants/ActionTypes'
import { featureFlags } from '../store/initialState'

/**
 * @typedef {import('../types/plottr').FeatureFlags} FeatureFlags
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @template A
 * @typedef {import('../types/reducer').DataRepairer<A>} DataRepairer
 */

/**
 * @type {FeatureFlags}
 */
const INITIAL_STATE = featureFlags

/**
 * @param {DataRepairer<any>} _dataRepairers
 * @return {function(FeatureFlags, PltrAction): FeatureFlags}
 */
const featureFlagsReducer =
  (_dataRepairers) =>
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case SET_FEATURE_FLAG:
        return {
          ...state,
          [action.flagName]: true,
        }
      case UNSET_FEATURE_FLAG:
        return {
          ...state,
          [action.flagName]: false,
        }

      case FILE_LOADED:
        return action.data.featureFlags || INITIAL_STATE

      case NEW_FILE:
        return INITIAL_STATE

      case LOAD_FEATURE_FLAGS:
        return action.featureFlags

      default:
        return state
    }
  }

export default featureFlagsReducer
